import * as React from 'react'
import { Styled } from './styled'

export const Switcher = (props) => {
  const { checked, onChange, size = 's', disabled = false } = props;
  return (
    <Styled.SwitcherContainer
      onClick={onChange && onChange}
      checked={checked}
      size={size}
      disabled={disabled}
    >
      <Styled.Round checked={checked} size={size} />
    </Styled.SwitcherContainer>
  )
}
